import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const BANNER_CONTEXT_SYMBOL = Symbol();
const useBanner = ()=>useImmutableContext(BANNER_CONTEXT_SYMBOL);
const useBannerProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(BANNER_CONTEXT_SYMBOL, ...args);
};
export { useBanner, useBannerProvider };
